import moment from "moment";
import { useSelector } from "react-redux";
import styled from "styled-components";

// export const CI_coverType = () => { return useSelector((state) => state.CI.coverType); }

export const CustomLabel = styled.label`
  font-size: ${(props) => (props.font_size ? props.font_size : "16")}px;
  font-weight: ${(props) => (props.font_weight ? props.font_weight : "bold")};
  margin-top: ${(props) => (props.margin_top ? props.margin_top : "0")}px;
  line-height: 1;
  color: ${(props) => (props.color ? props.color : "black")};
  @media (max-width: 767px) {
    font-size: ${(props) => (props.font_size ? props.font_size - 1 : "12")}px;
  }
`;

export const product_static_list_data = [
  "Upgrade your Lifetime Health Insurance with the newly launched ManipalCigna Health 360 riders.",
  "Continuity Benefit on entire SI chosen for existing base SI of 10Lacs or above.",
  "Unlimited Restoration for unrelated illnesses.",
  "Premium waiver benefit for next one year renewal premium.",
  "Loyalty discount of 5% from 4th policy year onwards & 10% from 8th year onwards.",
];

export const primesenior_product_static_list_data = [
  "Avail treatment in a room category higher than your eligibility and get charged only for the additional difference pertaining to the difference in room rent only",
  "Simplistic on-boarding to ensure hassle free purchase of plan",
  "A plan with provision for coverage without co-payments and sub-limits even for higher ages",
  "A plan that gives you flexibility with lower waiting periods and provides coverage practically from day 1*",
  "Flexible Health Check-up to be updated with your Health status from our network providers.",
];

export const prohealth_prime_product_static_list_data = [
  "With Non medical expenses now covered get no surprises in your hospitalization bills and receive 100% of claim.",
  "Switch off your cover when you won't be needing it, like while abroad, for a month & get a discount on the next premium.",
  "No cap on room limit be it a Single AC room, suite or even above.",
  "Unlimited Restoration of Sum Insured for Related and Unrelated illnesses.",
  "Active Plan specifically made for people with pre-existing conditions like asthma, diabetes, hypertension, dyslipidemia, & obesity.",
];

export const plainOptions = ["Family", "Multi Individual"];
export const accident_plainOptions = ["Family Floater", "Multi Individual"];

export const typeOFCOVER = {
  ff: "Family",
  ml: "Multi Individual",
  in: "Individual",
};

export const accident_typeOFCOVER = {
  ff: "Family Floater",
  ml: "Multi Individual",
  in: "Individual",
};

export const acide_plainOptions_forSelect = [
  {
    label: "Family Floater",
    value: "familyfloater",
  },
  {
    label: "Multi Individual",
    value: "Multi Individual",
  },
];

export const plainOptions_forSelect = [
  {
    label: "Family",
    value: "Family",
  },
  {
    label: "Multi Individual",
    value: "Multi Individual",
  },
];

export const initial_selct_options = [
  { label: "Select Relationship", value: "" },
  {
    label: "Self",
    value: "SELF",
  },
];

export const adult_select_options = [
  { label: "Select Relationship", value: "" },
  {
    label: "Self",
    value: "SELF",
  },
  {
    label: "Husband",
    value: "SPOUSE",
  },
  {
    label: "Wife",
    value: "SPOUSE",
  },
  {
    label: "Mother",
    value: "MOTHER",
  },
  {
    label: "Father",
    value: "FATHER",
  },
  {
    label: "Mother-in-law",
    value: "MOTHERINLAW",
  },
  {
    label: "Father-in-law",
    value: "FATHERINLAW",
  },
  {
    label: "Son",
    value: "SON",
  },
  {
    label: "Daughter",
    value: "DAUGHTER",
  },
  {
    label: "Brother",
    value: "BROTHER",
  },
  {
    label: "Sister",
    value: "SISTER",
  },
];

export const female_adult_select_options = [
  { label: "Select Relationship", value: "" },

  {
    label: "Wife",
    value: "SPOUSE",
  },
  {
    label: "Mother",
    value: "MOTHER",
  },

  {
    label: "Mother-in-law",
    value: "MOTHERINLAW",
  },

  {
    label: "Daughter",
    value: "DAUGHTER",
  },

  {
    label: "Sister",
    value: "SISTER",
  },
];

export const male_adult_select_options = [
  { label: "Select Relationship", value: "" },
  {
    label: "Husband",
    value: "SPOUSE",
  },
  {
    label: "Father",
    value: "FATHER",
  },
  {
    label: "Father-in-law",
    value: "FATHERINLAW",
  },
  {
    label: "Son",
    value: "SON",
  },
  {
    label: "Brother",
    value: "BROTHER",
  },
];

export const child_select_options = [
  { label: "Select Relationship", value: "" },
  {
    label: "Son",
    value: "SON",
  },
  {
    label: "Daughter",
    value: "DAUGHTER",
  },
  {
    label: "Brother",
    value: "BROTHER",
  },
  {
    label: "Sister",
    value: "SISTER",
  },
  {
    label: "Grandson",
    value: "GRANDSON",
  },
  {
    label: "GrandDaughter",
    value: "GRANDDAUGHTER",
  },
];

export const pa_female_child_select_options = [
  { label: "Select Relationship", value: "" },
  {
    label: "Daughter",
    value: "DAUGHTER",
  },
  {
    label: "Sister",
    value: "SISTER",
  },
];

export const pa_male_child_select_options = [
  { label: "Select Relationship", value: "" },
  {
    label: "Son",
    value: "SON",
  },
  {
    label: "Brother",
    value: "BROTHER",
  },
];

export const female_child_select_options = [
  { label: "Select Relationship", value: "" },
  {
    label: "Daughter",
    value: "DAUGHTER",
  },
  {
    label: "Sister",
    value: "SISTER",
  },
  {
    label: "GrandDaughter",
    value: "GRANDDAUGHTER",
  },
];

export const male_adult_select_options_sarvah = [
  { label: "Select Relationship", value: "" },
  {
    label: "Self",
    value: "SELF",
  },
  {
    label: "Husband",
    value: "SPOUSE",
  },
  // {
  //   label: "Live-in partner",
  //   value: "LIVEINPARTNER",
  // },
  {
    label: "Father",
    value: "FATHER",
  },
  {
    label: "Father-in-law",
    value: "FATHERINLAW",
  },
  {
    label: "Son",
    value: "SON",
  },
  {
    label: "Brother",
    value: "BROTHER",
  },
  {
    label: "Uncle",
    value: "UNCLE",
  },
  {
    label: "Nephew",
    value: "NEPHEW",
  },
  {
    label: "Son-in-Law",
    value: "SONINLAW",
  },
  {
    label: "GrandFather",
    value: "GRANDFATHER",
  },
  {
    label: "Brother-in-Law",
    value: "BROTHERINLAW",
  },
];

export const female_adult_select_options_sarvah = [
  { label: "Select Relationship", value: "" },

  {
    label: "Self",
    value: "SELF",
  },
  {
    label: "Wife",
    value: "SPOUSE",
  },
  // {
  //   label: "Live-in partner",
  //   value: "LIVEINPARTNER",
  // },
  {
    label: "Mother",
    value: "MOTHER",
  },

  {
    label: "Mother-in-law",
    value: "MOTHERINLAW",
  },

  {
    label: "Daughter",
    value: "DAUGHTER",
  },

  {
    label: "Sister",
    value: "SISTER",
  },
  {
    label: "Aunt",
    value: "AUNT",
  },
  {
    label: "Niece",
    value: "NIECE",
  },
  {
    label: "Daughter-in-Law",
    value: "DAUGHTERINLAW",
  },
  {
    label: "GrandMother",
    value: "GRANDMOTHER",
  },
  {
    label: "Sister-in-Law",
    value: "SISTERINLAW",
  },
];

export const adult_select_options_sarvah = [
  { label: "Select Relationship", value: "" },
  {
    label: "Self",
    value: "SELF",
  },
  {
    label: "Husband",
    value: "SPOUSE",
  },
  {
    label: "Wife",
    value: "SPOUSE",
  },
  // {
  //   label: "Live-in partner",
  //   value: "LIVEINPARTNER",
  // },
  {
    label: "Mother",
    value: "MOTHER",
  },
  {
    label: "Father",
    value: "FATHER",
  },
  {
    label: "Mother-in-law",
    value: "MOTHERINLAW",
  },
  {
    label: "Father-in-law",
    value: "FATHERINLAW",
  },
  // {
  //   label: "Son",
  //   value: "SON",
  // },
  // {
  //   label: "Daughter",
  //   value: "DAUGHTER",
  // },
  {
    label: "Uncle",
    value: "UNCLE",
  },
  {
    label: "Nephew",
    value: "NEPHEW",
  },
  {
    label: "Son-in-Law",
    value: "SONINLAW",
  },
  {
    label: "GrandFather",
    value: "GRANDFATHER",
  },
  {
    label: "Brother-in-Law",
    value: "BROTHERINLAW",
  },
  {
    label: "Aunt",
    value: "AUNT",
  },
  {
    label: "Niece",
    value: "NIECE",
  },
  {
    label: "Daughter-in-Law",
    value: "DAUGHTERINLAW",
  },
  {
    label: "GrandMother",
    value: "GRANDMOTHER",
  },
  {
    label: "Sister-in-Law",
    value: "SISTERINLAW",
  },
  {
    label: "Brother",
    value: "BROTHER",
  },
  {
    label: "Sister",
    value: "SISTER",
  },
];


export const female_child_select_options_sarvah = [
  { label: "Select Relationship", value: "" },
  {
    label: "Daughter",
    value: "DAUGHTER",
  },
  {
    label: "Sister",
    value: "SISTERCHILD",
  },
  {
    label: "Grand Daughter",
    value: "GRANDDAUGHTER",
  },
];

export const male_child_select_options_sarvah = [
  { label: "Select Relationship", value: "" },
  {
    label: "Son",
    value: "SON",
  },
  {
    label: "Brother",
    value: "BROTHERCHILD",
  },
  {
    label: "Grand Son",
    value: "GRANDSON",
  },
];

export const child_select_options_sarvah = [
  { label: "Select Relationship", value: "" },
  {
    label: "Son",
    value: "SON",
  },
  {
    label: "Daughter",
    value: "DAUGHTER",
  },
  {
    label: "Brother",
    value: "BROTHERCHILD",
  },
  {
    label: "Grand Son",
    value: "GRANDSON",
  },
  {
    label: "Sister",
    value: "SISTERCHILD",
  },
  {
    label: "Grand Daughter",
    value: "GRANDDAUGHTER",
  },
];

export const male_child_select_options = [
  { label: "Select Relationship", value: "" },
  {
    label: "Son",
    value: "SON",
  },
  {
    label: "Brother",
    value: "BROTHER",
  },
  {
    label: "Grandson",
    value: "GRANDSON",
  },
];

export const gender_select_options = [
  {
    label: "Gender",
    value: "",
  },
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Female",
    value: "FEMALE",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];

export const age_constant_minus = {
  0o1: 154244700000,
  0o5: 15776640000,
  25: 788918400000,
  17: 536457600000,
  18: 567993600000,
  19: 599529600000,
  91: 7862400000,
  30: 946684800000,
  31: 978265512000,
  26: 820454400000,
  23: 757382400000,
  0: -94734000000,
  1: 31536000000,
};

export const regex_obj = {
  income_number: /^\d+$/,
  emailValidation: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  pincode: /^[1-9][0-9]{5}$/,
  common: /[^a-zA-Z0-9.@_ ]/g,
  phoneNumberValid: /^(\d)(?!\1+$)\d{9}$/
};

export const validationOfField = (type, value) => {
  switch (type) {
    // case TYPE_OF_VALIDATION.email:
    //   if (regex_obj.emailValidation.test(value)) {
    //     return false;
    //   }
    //   return true;
    // case TYPE_OF_VALIDATION.Mobile:
    //   if (value.length === 10) {
    //     return false;
    //   }
    //   return true;

    case TYPE_OF_VALIDATION.pincode:
      if (value.length === 12) {
        return false;
      }
      return true;
  }
};

export const si_select_options = ({ uppercap, type }) => {
  let obj = { value: "", label: "" };
  const newArr = [{ value: "", label: "cover" }];

  if (type === typeOfCal.accident_Shield) {
    // obj = { label: "1 lacs", value: "100000" };
    //    newArr.push(obj);
    for (let i = 5; i <= uppercap; i = i + 5) {
      let newObj = { ...obj };
      if (i < 100) {
        newObj.value = parseInt(i) * 100000;
        newObj.label = `${i} lacs`;
        newArr.push(newObj);
      } else if (i === 100) {
        newObj.value = parseInt(i) * 100000;
        newObj.label = `${i / 100} crore`;
        newArr.push(newObj);
      } else if ((i % 100) % 10 === 0) {
        newObj.value = parseInt(i) * 100000;
        newObj.label = `${i / 100} crores`;
        newArr.push(newObj);
      }
    }
    return newArr;
  }

  if (type === typeOfCal.pa) {
    // obj = { label: "1 lacs", value: "100000" };
    for (let i = 0.5; i <= uppercap; i + 0.5) {
      let newObj = { ...obj };
      if (i < 100) {
        newObj.value = parseInt(i) * 100000;
        newObj.label = `${i} lacs`;
        newArr.push(newObj);
      } else if (i === 100) {
        newObj.value = parseInt(i) * 100000;
        newObj.label = `${i / 100} crore`;
        newArr.push(newObj);
      } else if ((i % 100) % 10 === 0) {
        newObj.value = parseInt(i) * 100000;
        newObj.label = `${i / 100} crores`;
        newArr.push(newObj);
      }
    }
    return newArr;
  }

  for (let i = 1; i <= uppercap; i++) {
    let newObj = { ...obj };
    if (i < 100) {
      newObj.value = parseInt(i) * 100000;
      newObj.label = `${i} lacs`;
      newArr.push(newObj);
    } else if (i === 100) {
      newObj.value = parseInt(i) * 100000;
      newObj.label = `${i / 100} crore`;
      newArr.push(newObj);
    } else if ((i % 100) % 10 === 0) {
      newObj.value = parseInt(i) * 100000;
      newObj.label = `${i / 100} crores`;
      newArr.push(newObj);
    }
  }
  return newArr;
};

export const si_select_options_pa = ({ uppercap, type }) => {
  const obj = { value: "", label: "" };
  const newArr = [{ value: "", label: "cover" }];
  for (let i = 0.5; i <= uppercap; i += 0.5) {
    let newObj = { ...obj };
    if (i < 100) {
      newObj.value = i * 100000;
      newObj.label = `${i} lacs`;
      newArr.push(newObj);
    } else if (i === 100) {
      newObj.value = parseInt(i) * 100000;
      newObj.label = `${i / 100} crore`;
      newArr.push(newObj);
    } else if ((i % 100) % 10 === 0) {
      newObj.value = parseInt(i) * 100000;
      newObj.label = `${i / 100} crores`;
      newArr.push(newObj);
    }
  }
  return newArr;
};

export const si_select_options_sa = ({ uppercap, type }) => {
  const obj = { value: "", label: "" };
  const newArr = [{ value: "", label: "cover" }];
  for (let i = 2.5; i <= uppercap; i+= 0.5) {
    let newObj = { ...obj };
    if (i < 100) {
      newObj.value =  i * 100000;
      newObj.label = `${i} lacs`;
      newArr.push(newObj);
    }
    else if (i === 100) {
      newObj.value = parseInt(i) * 100000;
      newObj.label = `${i / 100} crore`;
      newArr.push(newObj);
    } else if (((i % 100) % 10) === 0) {
      newObj.value = parseInt(i) * 100000;
      newObj.label = `${i / 100} crores`;
      newArr.push(newObj);
    }
  }
  return newArr;
};

export const TYPE_OF_VALIDATION = {
  email: "EMAIL",
  Mobile: "MOBILE",
  pincode: "PINCODE",
};

export const coverType_constant = {
  ff: "familyfloater",
  in: "individual",
  ml: "multiindividual",
};
export const new_product_static_list_data = [
  {
    key: 1,
    icon: "01",
    desc: "Comprehensive Hospitalization coverage up to Rs 3 Cr without any sub-limits or Co-Pay.",
  },
  {
    key: 2,
    icon: "02",
    desc: "Gullak (Guaranteed Cumulative Bonus) increases coverage by 100% in each policy year, up to 15X of the opted base Sum Insured (1500%), irrespective of claims.",
  },
  {
    key: 3,
    icon: "03",
    desc: "Get unlimited Restoration of base Sum Insured for all illnesses and injury.",
  },
  {
    key: 4,
    icon: "04",
    desc: "With Surplus Benefit get an additional 100% of your Sum Insured from Day 1 for the first claim in each policy.",
  },
  {
    key: 5,
    icon: "05",
    desc: "No Zonal Co-Payment, if treatment taken at higher zone.",
  },
];

export const isEqualArray = (a ,b) =>{
  return JSON.stringify(a.sort()) === JSON.stringify(b.sort())
}

export const coverType = (adult, child, type, userData) => {
  const relationshipfromuserData = userData.adultData.map(user => user.relationship)
  const childAges = userData.childData?.length > 0 &&  userData.childData.filter(value => +value.dob >= 18 &&  +value.dob <= 30)
  const isChildAgePresent = childAges.length > 0
  /** RelationShip check for  (adult  == 2 && child == 0  sravah*/
  let SELF_SPOUSE = ['SELF', 'SPOUSE']
  let FAT_MOT = ['FATHER', 'MOTHER']
  let FIL_MIL = ['FATHERINLAW', 'MOTHERINLAW']
  const isRelationMeet = isEqualArray(SELF_SPOUSE, relationshipfromuserData) || isEqualArray(FAT_MOT , relationshipfromuserData) || isEqualArray(FIL_MIL , relationshipfromuserData)
 
  const isChildRelationvalidforMultiIndVisual = userData.childData
  .some((data) =>
    data.relationship == "GRANDSON" ||
    data.relationship == "GRANDDAUGHTER" ||
    data.relationship == "BROTHERCHILD" ||
    data.relationship == "SISTERCHILD" 
)
 
  /** end */
  switch (type) {
    case typeOfCal.lifetime:
    case typeOfCal.prohealthPrime:
    case typeOfCal.prohealth:
    case typeOfCal.superTopUp:
      if (adult + child === 1) {
        return coverType_constant.in;
      } else if (adult > 2 || child > 3 || adult === 0) {
        return coverType_constant.ml;
      } else {
        return coverType_constant.ff;
      }
    case typeOfCal.primeSenior:
      if (adult === 1) {
        return coverType_constant.in;
      } else if (adult === 2) {
        return coverType_constant.ff;
      } else {
        return coverType_constant.ml;
      }

    case typeOfCal.accident_Shield:
    case typeOfCal.ci:
      if (adult + child == 1) {
        return coverType_constant.in;
      }
      case typeOfCal.mchiSarvah:
        if (adult + child === 1) {
          return coverType_constant.in;
        }else if (adult  == 2 && child == 0 && isRelationMeet ) {
          return coverType_constant.ff;
        } else if (adult  == 1 && child >=1 && child <=3 && SELF_SPOUSE.includes(userData.adultData[0].relationship)  && isChildAgePresent && !isChildRelationvalidforMultiIndVisual ) {
          return coverType_constant.ff;
        } else if (adult  == 2 && child >=1 && child <=3 && isEqualArray(SELF_SPOUSE ,relationshipfromuserData)  && isChildAgePresent  && !isChildRelationvalidforMultiIndVisual) {
          return coverType_constant.ff;
        }else if(adult  == 2 && child >=1 && child <=8  && childAges.length == 0) {
          return coverType_constant.ml;
        } else {
          return coverType_constant.ml;
        }
    case typeOfCal.pa:
      if (adult + child == 1) {
        return coverType_constant.in;
      }
      return null;
  }
};

export const typeOfCal = {
  lifetime: "life-time",
  prohealthPrime: "prohealth-prime",
  primeSenior: "prime-senior",
  prohealth: "prohealth",
  superTopUp: "super-top-up",
  ci: "critical-illness",
  pa: "personal accident",
  saral: "saral-surakhsa",
  accident_Shield: "accident_shield",
  mchiSarvah: "sarvah"
};

const calculateAge_coverType = () => {};

export const ageConditionOfType = (type, age, count) => {
  switch (type) {
    case typeOfCal.accident_Shield:
      return age > 70;
    case typeOfCal.mchiSarvah:
      return age > 120;
    case typeOfCal.lifetime:
    case typeOfCal.ci:
      return age > 65;
    case typeOfCal.pa:
      return age > 80;
    case typeOfCal.prohealthPrime:
      break;
    case typeOfCal.primeSenior:
      return age < 56 || age > 75;
  }
};
